// RecommendedLessons.jsx
import React from 'react';
import ExpandableSection from '../ui/ExpandableSection';
import RecommendedLessonCard from './RecommendedLessonCard';

import { 
  GiftIcon,
} from '../common/IconsComponent';


const RecommendedLessons = ({
  recommendedLessons,
  isExpanded,
  onToggleExpand,
  onAddToCart
}) => {
  
  return (
    <ExpandableSection
      title="שיעורים מומלצים עבורך"
      icon={<GiftIcon size={20} />}
      iconClassName="text-orange-500"
      isExpanded={isExpanded}
      onToggle={onToggleExpand}
    >
      <div className="px-6 pb-6">
        <p className="text-gray-600 mb-4">שיעורים נוספים שיכולים לעניין אותך</p>
        
        <div className="space-y-4">
          {recommendedLessons.length > 0 ? (
            recommendedLessons.map(lesson => (
              <RecommendedLessonCard
                lesson={lesson}
                onAddToCart={onAddToCart}
              />
            ))
          ) : (
            <p className="text-gray-500 text-center py-4">אין שיעורים מומלצים כרגע</p>
          )}
        </div>
      </div>
    </ExpandableSection>
  );
};

export default RecommendedLessons;